<template>
  <q-select
    v-model.trim="selectedDate"
    v-bind="$attrs"
  >
    <template #selected-item="{ opt }">
      {{ selectedDatesString(opt) }}
    </template>

    <template #append>
      <q-icon
        name="event"
        class="cursor-pointer"
      >
        <q-popup-proxy
          cover
          transition-show="scale"
          transition-hide="scale"
        >
          <q-date
            v-model="selectedDate"
            mask="YYYY-MM-DD"
            :options="dateOptionsForPicker"
            @update:model-value="handleDateChange"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-select>
</template>

<script>
import { date } from 'quasar'
import { IsoDate, IsoDateTime } from 'src/models/model'

const { extractDate } = date

const toIso = (value) => (value ? value.replace(/\//g, '-') : null) // -> 'YYYY-MM-DD'
const toPickerFormat = (value) => (value ? value.replace(/-/g, '/') : null) // -> 'YYYY/MM/DD'

export default {
  name: 'ActivityDateSelector',
  configuration: ['currentSite'],
  props: {
    activityId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initialDate: {
      type: String,
      default: null
    },
    showAllOption: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select-date'],
  data () {
    return {
      selectedDate: toIso(this.initialDate)
    }
  },
  computed: {
    today () {
      return toIso(this.currentSite.businessDate)
    },
    tomorrow () {
      return toIso(this.currentSite.businessTomorrow)
    },
    availableDatesIso () {
      return this.datesWithActivities.value || []
    },
    dateOptionsForPicker () {
      return this.availableDatesIso.map(toPickerFormat)
    }
  },
  watch: {
    selectedDate: {
      handler (newDate) {
        if (!newDate) return
        this.$emit('select-date', newDate)
      },
      immediate: true
    },
    availableDatesIso: {
      handler (availableDates) {
        if (_.isEmpty(availableDates)) return

        if (!this.selectedDate || !availableDates.includes(this.selectedDate)) {
          this.selectedDate = availableDates[0]
        }
      },
      immediate: true
    }
  },
  methods: {
    handleDateChange (newDate) {
      this.selectedDate = toIso(newDate)
    },

    selectedDatesString (isoDate) {
      if (!isoDate || !IsoDate.parse(isoDate).isDate()) return ''

      const dateObj = extractDate(`${isoDate} 12:00`, 'YYYY-MM-DD HH:mm')
      const dateInSiteTime = this.currentSite.inSiteTime(new IsoDateTime(dateObj))
      const formattedDate = this.$i18n.d(dateInSiteTime, 'mediumDate')

      if (isoDate === this.today) {
        return `${this.$t('time.today')} ${formattedDate}`
      }

      if (isoDate === this.tomorrow) {
        return `${this.$t('time.tomorrow')} ${formattedDate}`
      }

      return formattedDate
    }
  },
  models: {
    datesWithActivities: {
      variables () {
        return {
          activity_id: this.activityId
        }
      },
      immediate: true,
      force: true
    }
  }
}
</script>
